import {onClick} from '../abstract/helpers.js';

export class OpenLoginPopup {
  constructor() {


    var button_list = document.querySelectorAll('.open-login-popup');
    button_list.forEach(button => {

      onClick(button, function (e) {
        e.preventDefault();

        let hasOpen = false;
        let hasAnimate = false;

        if(document.querySelector('#login-popup').classList.contains("open")) {
          hasOpen = false;
        } else {
          hasOpen = true;
        }

        if(hasOpen && document.querySelector('#login-popup').classList.contains("animate")) {
          document.querySelector('#login-popup').classList.remove('animate');
          setTimeout(() => {
            document.querySelector('#login-popup').classList.remove('open');
          }, 600);

          hasAnimate = true;
        } else if(hasOpen && !document.querySelector('#login-popup').classList.contains("animate")) {
          document.querySelector('#login-popup').classList.add('open');
          setTimeout(() => {
            document.querySelector('#login-popup').classList.add('animate');
          }, 10);
        } else {
          document.querySelector('#login-popup').classList.remove('animate');
          setTimeout(() => {
            document.querySelector('#login-popup').classList.remove('open');
          }, 600);
        }
        return false;
      });
    });

    var button_list_mobile = document.querySelectorAll('.open-login-popup-mobile');
    button_list_mobile.forEach(button2 => {

      console.log('run');
      onClick(button2, function (e) {
        console.log('called');
        e.preventDefault();

        let hasOpen = false;
        let hasAnimate = false;

        if(document.querySelector('#login-popup').classList.contains("open")) {
          hasOpen = false;
        } else {
          hasOpen = true;
        }

        if(hasOpen && document.querySelector('#login-popup').classList.contains("animate")) {
          document.querySelector('#login-popup').classList.remove('animate');
          setTimeout(() => {
            document.querySelector('#login-popup').classList.remove('open');
          }, 600);

          hasAnimate = true;
        } else if(hasOpen && !document.querySelector('#login-popup').classList.contains("animate")) {
          document.querySelector('#login-popup').classList.add('open');
          setTimeout(() => {
            document.querySelector('#login-popup').classList.add('animate');
          }, 10);
        } else {
          document.querySelector('#login-popup').classList.remove('animate');
          setTimeout(() => {
            document.querySelector('#login-popup').classList.remove('open');
          }, 600);
        }
        return false;
      });
    });

  }
}
